// THE ABOUT ROOM — the community explained from the side of the people in it:
// who keeps what here, how a skill gets from one person to every ai, and what
// happens to an author's name. Plain prose in the house voice; every claim is
// something the product does today.

import Link from "next/link";

const WHO: [string, string][] = [
  ["innernet", "the skills we keep ourselves, and the best ones builders already share in the open, credited to them and linked to where they live."],
  ["members", "anyone with an innernet. a page you open to anyone with its link lands here under your name, always as the version you keep now."],
  ["the people who wrote them", "a skill someone brings in from github, a gist, or a post is listed under its author's name first, with the member who brought it beside them."],
];

const HOW: [string, string][] = [
  ["copy a link", "every card has a small round button. press it, paste the link into claude, chatgpt, cursor or anything that reads, and it knows what to do."],
  ["ask from a chat", "with innernet connected, your ai can look the shelf up by what you are doing, offer the skills that fit, use one on the spot, or keep it in your innernet."],
  ["open your own", "from your dashboard, open a door on any page of yours and choose who it opens for and the ground it opens in. a skill that is open appears here."],
  ["bring someone's", "hand your ai an install line, a skills.sh page, a github link or a post. innernet finds the repo it points at and reads the skill from there. no node, nothing installed."],
];

export default function AboutBody() {
  return (
    <article className="cm-about">
      <p className="cm-about__lede">
        the community is a shelf of things an ai can learn from a link, kept in the open. it exists so that whatever you
        learn to do well, and whatever someone else figured out before you, is one link away from every tool you think with.
      </p>

      <h2 className="cm-about__h">who is here</h2>
      <div className="detail-rows cm-about__rows">
        {WHO.map(([k, v]) => (
          <div key={k} className="detail-row"><span>{k}</span><span>{v}</span></div>
        ))}
      </div>

      <h2 className="cm-about__h">how a skill moves</h2>
      <div className="cm-about__grid">
        {HOW.map(([k, v], i) => (
          <div key={k} className="cm-about__step">
            <span className="cm-about__n">{String(i + 1).padStart(2, "0")}</span>
            <span className="cm-about__k">{k}</span>
            <span className="cm-about__v">{v}</span>
          </div>
        ))}
      </div>

      <h2 className="cm-about__h">an author is always first</h2>
      <p className="cm-about__p">
        a skill is its author&rsquo;s. the words stay exactly as they wrote them, their name comes first, and the link goes
        back to where they shared it. the same skill is never listed twice, and once an author is recorded nobody can quietly
        change who it belongs to. we write to them once, with the skill as it looks on the shelf and one link that takes it
        down. no reason needed.
      </p>

      <h2 className="cm-about__h">what we count</h2>
      <p className="cm-about__p">
        a copy of a link, a save into someone&rsquo;s innernet, an ai pulling a skill to use it, a card opened from the shelf.
        numbers only, never who. that is what <b>top</b> is ordered by.
      </p>

      <h2 className="cm-about__h">the other rooms</h2>
      <p className="cm-about__p">
        <Link className="quiet-link" href="/community/guides">guides</Link> are short, honest walkthroughs for the parts of
        innernet worth learning once. <Link className="quiet-link" href="/community/resources">resources</Link> are the tools,
        clients and reading that go well with a memory of your own.
      </p>

      <p className="cm-about__foot">
        <Link className="quiet-link" href="/community">browse the skills</Link> ·{" "}
        <Link className="quiet-link" href="/skills/bring-a-skill">how to bring one</Link> ·{" "}
        <Link className="quiet-link" href="/skills/skill-format">what a skill is</Link>
      </p>
    </article>
  );
}
